import React from 'react';
import { theme } from '@frontend/theme';

export const PaddedContent = ({ children, ...rest }: { children: React.ReactNode; className?: string }) => (
  <div css={{ padding: theme.spacing(3), display: 'flex', flexDirection: 'column' }} {...rest}>
    {children}
  </div>
);
